import React from "react";
import { useRef, useEffect } from "react";

function AppAccordian({ data = [], id = "accordionExample",active=1,onActive=(()=>('')) }) {
  const accordian = useRef();
  const isActive = (i)=>(active==(i+1));

  return (
    <div ref={accordian} className="accordion custom_accordion" id={id}>
      {data.map(
        (
          {
            Content = () => <div>Accordian Content</div>,
            Title = () => (
              <button className="btn btn-link" type="button">
                Collapsible Group Item #1
              </button>
            ),
          },
          i
        ) => (
          <div className={Object.className({"accordion-item":true,"active":isActive(i)})} key={i}>
            <h2 className="accordion-header" id={"heading" + i}>
              <button
                className={Object.className({"accordion-button text-base":true,"collapsed":!isActive(i)})}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={"#collapse" + i}
                aria-expanded="true"
                aria-controls={"collapse" + i}
                onClick={()=>onActive(i+1)}
              >
                <Title />
              </button>
            </h2>
            <div
              id={"collapse" + i}
              className={Object.className({"accordion-collapse collapse":true,"show":isActive(i)})}
              aria-labelledby={"heading" + i}
              data-bs-parent={"#" + id}
            >
              <div className="accordion-body">
                <Content />
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
}

export default AppAccordian;
